import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const GroupManagementMembersPage = withSuspense(
	lazy(async () => await import('./group-management-members-page.component')),
	PageLoader,
);
